import { api } from ".";

export interface ProviderCount {
  id: number;
  name: string;
  count: number;
}

export interface CategoryStats {
  total: number;
  byProvider: ProviderCount[];
}

export interface CategoriesStats {
  countries: CategoryStats;
  sports: CategoryStats;
  leagues: CategoryStats;
}

export const getCategoriesStats = async (): Promise<CategoriesStats> => {
  const res = await api.client.get("/categories-stats");
  return res.data;
};
